/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License version 3.0
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License version 3.0
 */

$(document).ready(function () {

    $(document).on('click', 'button.js-add-to-cart-club', function (e) {
        e.preventDefault();
        const idProduct = $(this).parents('form').find('input[name="id_product"]').val();
        $('#btnConfirmer').data('id-product', idProduct);
        $(document).find("#confirmationModalClub").modal("show");
    });

    prestashop.on('updatedCart', () => {
        // Recharge uniquement le bloc #club-offers-section depuis la page courante
        $('#club-offers-section').load(document.URL + ' #club-offers-section > *');

        //recharger de la modale de confirmation
        $('#confirmationModalClub').load(document.URL + ' #confirmationModalClub > *');
    });

    $(document).on("click",'#btnConfirmer', function () {
        $(document).find("#confirmationModalClub").modal("hide");

        const id_product = $(this).data('id-product');
        $.ajax({
            type: 'POST',
            url: '',
            data: {
                ajax: 1,
                action: 'addToCartClubAjax',
                id_product: id_product
            },
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    prestashop.emit('updateCart', {
                        reason: {
                            idProduct: id_product,
                            idProductAttribute: 0,
                            linkAction: 'add-to-cart'
                        },
                        resp: {
                            id_product: id_product,
                            success: true
                        }
                    });
                } else {
                    alert(response.message || "Erreur lors de l'ajout au panier.");
                }
            },
            error: function (alertes) {
                alert("Erreur serveur, veuillez réessayer.");
            }
        });
    });
});
